import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FichaDaObraService } from 'src/app/ficha-da-obra/service/ficha-da-obra.service';
import { ErrorHandleService } from 'src/app/shared/services/error-handle/error-handle.service';
import { SucessoComponent } from '../../sucesso/sucesso.component';

@Component({
  selector: 'app-obra-descartada',
  standalone: true,
  imports: [CommonModule, FormsModule, SucessoComponent],
  templateUrl: './obra-descartada.component.html',
  styleUrls: ['./obra-descartada.component.scss'],
})
export class ObraDescartadaComponent implements OnInit {
  @Output() actionConfirmed = new EventEmitter<void>();
  @Input() idObra: number | null = null;
  @Input() moduloId: number | null = null;
  @Output() close = new EventEmitter<void>();
  @Output() loading = new EventEmitter<boolean>();

  taskDescription = '';
  responsavelSelecionado: string = '';
  concorrenteSelecionado: string = '';
  motivoSelecionado: string = '';
  sucesso = false;
  campoObrigatorioErro: boolean = false;
  responsavel: any[] = [];

  private _errorHandleService = inject(ErrorHandleService);

  constructor(private fichaDaObraService: FichaDaObraService) {}

  ngOnInit(): void {
    this.popularResponsavel();
  }

  clear(): void {
    this.taskDescription = '';
    this.motivoSelecionado = null;
    this.responsavelSelecionado = null;
  }

  continuar() {
    this.sucesso = false;
    this.actionConfirmed.emit();
  }

    popularResponsavel(): void {
    this.fichaDaObraService.popularResponsavelObra().subscribe(
      (response) => {
       this.responsavel = response.data.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
      },
      (error) => {
        console.error('Erro ao buscar ações:', error);
      }
    );
  }

  atualizarObraDescartada(): void {
    this.loading.emit(true);

    if (!this.idObra) {
      console.error('idObra não informado');
      this.loading.emit(false);
      return;
    }

      if (!this.responsavelSelecionado) {
    this.campoObrigatorioErro = true;
    this.loading.emit(false);
    return;
  } else {
    this.campoObrigatorioErro = false;
  }

    const body = {
      marketID: 1,
          responsibleID: Number(this.responsavelSelecionado),
      description: this.taskDescription || '',
    };

    this.fichaDaObraService.updateClienteMercado(this.idObra, body, this.moduloId).subscribe({
      next: (res) => {
        this.loading.emit(false);
        if (res.success) {
          this.sucesso = true;
        } else {
          this._errorHandleService.throwConsoleError(res.message);
        }
      },
      error: (err) => {
        this.loading.emit(false);
        console.error('Erro ao atualizar obra contratada', err);
        this._errorHandleService.throwConsoleError(err.message);
      },
    });
  }
}
